export default () => ({
    list: [],
});
